import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import MultiSelect from "@khanacademy/react-multi-select"
class MultiSelectCustom extends Component {
  constructor() {
    super()
    this.handleChange = this.handleChange.bind(this)
    this.state = {
      selected: []
    }
  }
  handleChange() {}
  render() {
    return (
      <div>
        <MultiSelect
          options={this.props.data}
          selected={this.props.selected}
          valueRenderer={this.props.valueRenderer}
          onSelectedChanged={this.props.onChange}
          selectAllLabel="Selecionar todos"
        />
        <span className="label label-danger">{this.props.error}</span>
      </div>
    )
  }
}
export default withRouter(MultiSelectCustom)



// WEBPACK FOOTER //
// ./src/components/MultiSelectCustom.js